export const getTableContainerHeight = (ref) => {
  if (ref.current) {
    const scrollY = ref.current.clientHeight;
    return `${scrollY}px`;
  }

  return "420px";
};
